export enum AbortProcessReasons {
    cardioHolterTooSmall = 'cardioHolterTooSmall',
    cardioRecordingNotStarted = 'cardioRecordingNotStarted',
    doubleEntry = 'doubleEntry',
    doubleReferral = 'doubleReferral',
    failed = 'failed',
    languageBarrier = 'languageBarrier',
    mistakeInReferral = 'mistakeInReferral',
    newQuestionnairesSent = 'newQuestionnairesSent',
    nonContractedCare = 'nonContractedCare',
    noPhotosAdded = 'noPhotosAdded',
    noSmartphone = 'noSmartphone',
    noSuitableSmartphone = 'noSuitableSmartphone',
    other = 'other',
    otherMedicalPathway = 'otherMedicalPathway',
    patientRefrainsFromExaminationOrNoInterest = 'patientRefrainsFromExaminationOrNoInterest',
    preferenceForPhysicalConsultations = 'preferenceForPhysicalConsultations',
    softwareTooDificult = 'softwareTooDificult',
    test = 'test',
    tooExpensiveOrExcessBurden = 'tooExpensiveOrExcessBurden',
    unableContactWithPatient = 'unableContactWithPatient',
    unknownReason = 'unknownReason',
    wrongEntry = 'wrongEntry',
    wrongPatient = 'wrongPatient',
    wrongPhotos = 'wrongPhotos',
}
